import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

function Home() {
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        message: '',
    });
    const [errors, setErrors] = useState({});
    const [submitSuccess, setSubmitSuccess] = useState('');


    const validate = () => {
        let validationErrors = {};
        if (!formData.first_name.trim()) {
            validationErrors.first_name = 'First Name is required';
        }
        if (!formData.last_name.trim()) {
            validationErrors.last_name = 'Last Name is required';
        }
        if (!formData.email.trim()) {
            validationErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            validationErrors.email = 'Invalid email format';
        }
        if (!formData.phone_number.trim()) {
            validationErrors.phone_number = 'phone_number Number is required';
        } else if (!/^\d{10}$/.test(formData.phone_number)) {
            validationErrors.phone_number = 'phone_number Number must be 10 digits';
        }
        if (!formData.message.trim()) {
            validationErrors.message = 'Message is required';
        }
        return validationErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' }); // Clear error for the field being updated
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {
            const response = await fetch('https://admin.budgetbibleapp.com/api/contact-us', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                setSubmitSuccess('Thank you for reaching out! We will get back to you soon.');
                setFormData({
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone_number: '',
                    message: '',
                });
                setErrors({});
            } else {
                const errorData = await response.json();
                setSubmitSuccess(`Error: ${errorData.message || 'Something went wrong!'}`);
            }
        } catch (error) {
            setSubmitSuccess(`Error: ${error.message}`);
        }
    };

    return (
        <>
            <section className='landing_page_main'>

                <section id='home' className='top_section_home section'>
                    <div className='top_section'>
                        <div className='container'>
                            <div className='top_content_image'>
                                <div className='content_right'>
                                    <h1>Budget Your Paycheck</h1>
                                    <p >If you get paid weekly or bi-weekly,<br/>Why are you still using a monthly budget?<br/>Budget your paycheck with BYP.</p>
                                    <button type='button' className='btn' onClick={() => { const ua = navigator.userAgent || navigator.vendor || window.opera; const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream; const isAndroid = /Android/.test(ua); if (isIOS) { window.open('https://apps.apple.com/app/id6738954470', '_blank', 'noopener,noreferrer'); return; } if (isAndroid) { window.open('https://play.google.com/store/apps/details?id=com.budget_bible.android&pcampaignid=web_share', '_blank', 'noopener,noreferrer'); return; } const el = document.getElementById('download-app'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}>Download the App</button>
                                </div>
                                <div className='image_left_side'>
                                    <img className="hero_phone hero_phone_back" src="/images/byp-feature-planned-expenses.png" alt="BYP planned expenses screen" />
                                    <img className="hero_phone hero_phone_front" src="/images/byp-feature-budget-paycheck.png" alt="BYP paycheck dashboard" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                {/* <section id='about-us' className='about_section section'>
                    <div className='container'>
                        <div className='row g-5 align-items-center'>
                            <div className='col-lg-6'>
                                <div className='about_img'>
                                    <img src="/images/about_img.svg" alt="" />
                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <div className='about_content'>
                                    <h2 className='font-52'>About The Budget Bible</h2>
                                    <p>Lorem ipsum dolor sit amet consectetur adipiscing elit nunc facilisis incidunt diam vel dignissim sed id ultrices eros, Sed non suscipit ex duis mauris ligula tristique vitae eleifend in tincidunt at ipsum. Morbi odio purus, tempor vitae tellus eu molestie fringilla lacus. Fusce eleifend elementum pulvinar ntesque aliquet ipsum augue, non congue nisi porta ut.</p>
                                    <div className=''>
                                        <ul className='list_about'>
                                            <li> <span><img src="/images/check-circle.svg" alt="" /></span>Weekly Budget Planner (Helps you manage money between
                                                paychecks)</li>
                                            <li> <span><img src="/images/check-circle.svg" alt="" /></span>25 page guide that shows you how to budget your money
                                                every time you get paid</li>
                                            <li> <span><img src="/images/check-circle.svg" alt="" /></span>Undated Calendar</li>
                                            <li> <span><img src="/images/check-circle.svg" alt="" /></span>Monthly Expense / Income Tracker</li>
                                            <li> <span><img src="/images/check-circle.svg" alt="" /></span>Weekly Expense / Income Tracker</li>
                                            <li> <span><img src="/images/check-circle.svg" alt="" /></span>Premium Quality, Size A5, Leather, Gold page trim</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}

                <section id="key-features" className="app_screen_card_images section">
                    <div className='top_content'>
                        <h2 className='font-52'>Built Around Your Paycheck</h2>
                        <p className='font-20'>Budget each paycheck, manage your allowance, break up large bills, plan ahead, and see where your savings are going.
                        </p>
                    </div>
                    <Swiper
                        slidesPerView={'auto'}
                        spaceBetween={28}
                        grabCursor={true}
                        centeredSlides={true}
                        loop={true}
                        speed={1000}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: false,
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        modules={[Autoplay, Pagination]}
                        className="mySwiper"
                        effect="coverflow"
                        coverflowEffect={{
                            rotate: 0,
                            stretch: -20,
                            modifier: 1,
                            slideShadows: false,
                            scale: 0.6
                        }}
                    >
                        <SwiperSlide><img src="/images/byp-feature-allowance.png" alt="BYP allowance screen" /></SwiperSlide>
                        <SwiperSlide><img src="/images/byp-feature-split-expense.png" alt="BYP split expense screen" /></SwiperSlide>
                        <SwiperSlide><img src="/images/byp-feature-planned-expenses.png" alt="BYP planned expenses screen" /></SwiperSlide>
                        <SwiperSlide><img src="/images/byp-feature-savings-forecast.png" alt="BYP savings forecast screen" /></SwiperSlide>
                        <SwiperSlide><img src="/images/byp-feature-budget-paycheck.png" alt="BYP paycheck dashboard" /></SwiperSlide>
                        <SwiperSlide><img src="/images/byp-feature-allowance.png" alt="BYP allowance screen" /></SwiperSlide>
                        <SwiperSlide><img src="/images/byp-feature-split-expense.png" alt="BYP split expense screen" /></SwiperSlide>
                        <SwiperSlide><img src="/images/byp-feature-planned-expenses.png" alt="BYP planned expenses screen" /></SwiperSlide>
                        <SwiperSlide><img src="/images/byp-feature-savings-forecast.png" alt="BYP savings forecast screen" /></SwiperSlide>
                        <SwiperSlide><img src="/images/byp-feature-budget-paycheck.png" alt="BYP paycheck dashboard" /></SwiperSlide>

                    </Swiper>
                </section>


                <section id='download-app' className='download_app_section section'>
                    <div className='container'>
                        <div className='download_section'>
                            <div className='download_box'>
                                <h2 className='font-52'>Download from the Apple & Google Play Store</h2>
                                <p className='font-20'>Ready to manage your money between paychecks? Download BYP today.
                                </p>
                                <div className='download_button_play'>
                                    <a className='app_store_btn' href='https://apps.apple.com/app/id6738954470' target='_blank' rel='noopener noreferrer'><img src="/images/app_store.svg" alt="Download on the App Store" /></a>
<a className='app_store_btn' href='https://play.google.com/store/apps/details?id=com.budget_bible.android&pcampaignid=web_share' target='_blank' rel='noopener noreferrer'><img src="/images/google_play.svg" alt="Get it on Google Play" /></a>
                                </div>
                            </div>
                            <div className='download_box_tow'>
                                <div className='image_left_download'>
                                    <img src="/images/byp-download-app-mockup.png" alt="BYP app download mockup" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="contact-us" className="contact_section section">
                    <div className="container">
                        <div className="contact_content">
                            <h2 className="font-52">Contact Us</h2>
                            <p className="font-20">Have Questions? We’re Here to Help!</p>

                            <form className="contact_form" onSubmit={handleSubmit} noValidate>
                                <div className="row g-5">
                                    <div className="col-md-6 col-12">
                                        <input
                                            type="text"
                                            name="first_name"
                                            className="contact_input"
                                            placeholder="First Name"
                                            value={formData.first_name}
                                            onChange={handleChange}
                                            aria-describedby="first_nameError"
                                        />
                                        {errors.first_name && (
                                            <span id="first_nameError" className="error-text">
                                                {errors.first_name}
                                            </span>
                                        )}
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <input
                                            type="text"
                                            name="last_name"
                                            className="contact_input"
                                            placeholder="Last Name"
                                            value={formData.last_name}
                                            onChange={handleChange}
                                            aria-describedby="last_nameError"
                                        />
                                        {errors.last_name && (
                                            <span id="last_nameError" className="error-text">
                                                {errors.last_name}
                                            </span>
                                        )}
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <input
                                            type="email"
                                            name="email"
                                            className="contact_input"
                                            placeholder="Email Address"
                                            value={formData.email}
                                            onChange={handleChange}
                                            aria-describedby="emailError"
                                        />
                                        {errors.email && (
                                            <span id="emailError" className="error-text">
                                                {errors.email}
                                            </span>
                                        )}
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <input
                                            type="tel"
                                            name="phone_number"
                                            className="contact_input"
                                            placeholder="Phone Number"
                                            value={formData.phone_number}
                                            onChange={handleChange}
                                            aria-describedby="phone_numberError"
                                        />
                                        {errors.phone_number && (
                                            <span id="phone_numberError" className="error-text">
                                                {errors.phone_number}
                                            </span>
                                        )}
                                    </div>
                                    <div className="col-12">
                                        <textarea
                                            name="message"
                                            rows="4"
                                            className="contact_input text_area"
                                            placeholder="Write a message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            aria-describedby="messageError"
                                        />
                                        {errors.message && (
                                            <span id="messageError" className="error-text">
                                                {errors.message}
                                            </span>
                                        )}
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="btn submit_btn">Submit</button>
                                    </div>
                                </div>
                            </form>

                            {submitSuccess && <p className="submission-message">{submitSuccess}</p>}
                        </div>
                    </div>
                </section>
            </section>
        </>
    )
}

export default Home;